import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { isBrowser } from 'Helpers/Browser';

import Spinner from 'Components/layout/Spinner';
import Button from 'Components/layout/Button';

export default class CartSummaryPanel extends React.Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        onSelect: PropTypes.func.isRequired,
        creditsCount: PropTypes.number.isRequired,
        onSubmit: PropTypes.func.isRequired,
        totalPrice: PropTypes.number.isRequired,
        creditsPrice: PropTypes.number.isRequired,
        selectedPackageId: PropTypes.string,
        items: PropTypes.array,
        isBrand: PropTypes.bool.isRequired
    };
    static defaultProps = {
        isLoading: false,
        selectedPackageId: null
    };

    renderBrandPanel = () => {
        const { creditsCount, totalPrice, creditsPrice } = this.props;
        let photoCountToRemove = Math.ceil(totalPrice / 10);

        return (
            <div className={`component-cart-summary-panel credits small`}>
                <header className="summary-panel-header">
                    <div className="summary-panel-header-col summary-panel-header-col-left">
                        <span className="total-price-label">Total amount:</span>
                    </div>
                    <div className="summary-panel-header-col summary-panel-header-col-right">
                        <span className="total-price">
                            {creditsPrice + totalPrice} <small>credits</small>
                        </span>
                    </div>
                    {creditsPrice > 0 && totalPrice === 0 ?
                        <div className="packages-cta">
                            <Button
                                layout="full-width"
                                onClick={this.props.onSubmit}
                                className="btn-credits"
                                id="btn-checkout"
                            >
                                Buy and Pay with credits
                            </Button>
                        </div>
                        : null}
                    {creditsPrice > 0 && totalPrice > 0 && creditsCount > 0 ?
                        <p className="credits-buy-info">
                            You don’t have enough credits to your account to buy these photos. Please contact <a href="mailto:sales@foap.com">sales@foap.com</a> or remove {photoCountToRemove} {photoCountToRemove === 1 ? 'photo' : 'photos'} from the cart.
                        </p>
                        : null}
                    {creditsPrice === 0 && totalPrice > 0 && creditsCount === 0 ?
                        <p className="credits-buy-info">
                            You don’t have enough credits to your account to buy these photos. Please contact <a href="mailto:sales@foap.com">sales@foap.com</a>.
                        </p>
                        : null}
                </header>
                <div className={`summary-panel-package credits clearfix`}>
                    <p className="credits-balance-label">Your credits balance</p>
                    <p className="credits-balance">{creditsCount}</p>
                </div>
            </div>
        );
    }

    renderCurrencyPanel = () => {
        const { selectedPackageId, totalPrice } = this.props;

        return (
            <div className={`component-cart-summary-panel currency`}>
                <header className="summary-panel-header">
                    <div className="summary-panel-header-col summary-panel-header-col-left">
                        <span className="total-price-label">Total amount:</span>
                    </div>
                    <div className="summary-panel-header-col summary-panel-header-col-right">
                        <span className="total-price">
                            <small>$</small>{totalPrice.toFixed(2)}
                        </span>
                    </div>
                </header>
                <div className={`summary-panel-package ${selectedPackageId ? '' : 'selected'}`} onClick={() => this.props.onSelect('')}>
                    <div className={`summary-panel-package-col summary-panel-package-col-left`}>
                        <span className="radio-button">
                            <i className="fa fa-check"></i>
                        </span>
                    </div>
                    <div className="summary-panel-package-col summary-panel-package-col-middle">
                        <p className="package-credits">No Credit Package</p>
                        <p className="package-worth">No discount</p>
                    </div>
                </div>
            </div>
        );
    }

    renderCreditsPanel = () => {
        const { creditsCount, creditsPrice, items } = this.props;

        return (
            <div className={`component-cart-summary-panel credits small`}>
                <header className="summary-panel-header">
                    <div className="summary-panel-header-col summary-panel-header-col-left">
                        <span className="total-price-label">Total amount:</span>
                    </div>
                    <div className="summary-panel-header-col summary-panel-header-col-right">
                        <span className="total-price">
                            {creditsPrice} <small>credits</small>
                        </span>
                    </div>
                    {items.length && creditsCount > 0 ?
                        <div className="packages-cta">
                            <Button
                                layout="full-width"
                                onClick={this.props.onSubmit}
                                className="btn-credits"
                                id="btn-checkout"
                            >
                                Buy and Pay with credits
                            </Button>
                        </div>
                        : null}
                </header>
                <div className={`summary-panel-package credits clearfix`}>
                    <p className="credits-balance-label">Your credits balance</p>
                    <p className="credits-balance">{creditsCount}</p>
                </div>
            </div>
        );
    }

    renderMixedPanel = () => {
        const { selectedPackageId, creditsCount, totalPrice, creditsPrice } = this.props;

        return (
            <div className={`component-cart-summary-panel combined small`}>
                <header className="summary-panel-header">
                    <div className="summary-panel-header-col summary-panel-header-col-left">
                        <span className="total-price-label">Total amount:</span>
                    </div>
                    <div className="summary-panel-header-col summary-panel-header-col-right">
                        <span className="total-price">
                            <small>$</small> {totalPrice.toFixed(2)}
                            <p className="credits-additional-count">+ {creditsPrice} <small>credits</small></p>
                        </span>
                    </div>
                    <div className={`summary-panel-package credits clearfix`}>
                        <p className="credits-balance-label">Your credits balance</p>
                        <p className="credits-balance">{creditsCount}</p>
                    </div>
                </header>
                <div className={`summary-panel-package ${selectedPackageId ? '' : 'selected'}`} onClick={() => this.props.onSelect('')}>
                    <div className={`summary-panel-package-col summary-panel-package-col-left`}>
                        <span className="radio-button">
                            <i className="fa fa-check"></i>
                        </span>
                    </div>
                    <div className="summary-panel-package-col summary-panel-package-col-middle">
                        <p className="package-credits">No Credit Package</p>
                        <p className="package-worth">No discount</p>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { isLoading, selectedPackageId, creditsCount, totalPrice, creditsPrice, items, isBrand } = this.props;

        if (isLoading) {
            return (
                <div className="component-cart-summary-panel">
                    <Spinner className="relative" />
                </div>
            );
        } else {
            if (isBrand) {
                return this.renderBrandPanel();
            } else {
                if (creditsCount > 0 && totalPrice > 0) {
                    return this.renderMixedPanel();
                } else if ((creditsCount > 0 && totalPrice === 0)) {
                    return this.renderCreditsPanel();
                } else {
                    return this.renderCurrencyPanel();
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/public/cart/SummaryPanel/index.js